import { createReducer, Action, on } from '@ngrx/store';
import { State, initialState } from './state';
import * as actions from './actions';

const reducer = createReducer(
  initialState,
  on(actions.load, (state => {
    return {
      ...state,
      loading: true
    };
  })),
  on(actions.loadSuccess, ((state, { members })  => {
    return {
      ...state,
      loading: false,
      data: members
    };
  })),
  on(actions.loadFail, ((state, { error })  => {
    return {
      ...state,
      loading: false,
      error
    };
  })),
);

export function membersReducer(state: State, action: Action) {
  return reducer(state, action);
}
